module.exports = require('./vimeoUrlParser')
